import { render, staticRenderFns } from "./WeekChart.vue?vue&type=template&id=24d32bf4&scoped=true&"
import script from "./WeekChart.vue?vue&type=script&lang=js&"
export * from "./WeekChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d32bf4",
  null
  
)

export default component.exports